type Environment = "development" | "test" | "production";

const opUrls: Record<Environment, string> = {
  development:
    "https://api.defender.openzeppelin.com/actions/bc73ec90-bfe3-4208-9b98-38512882b7c1/runs/webhook/d2a70b55-ce91-4a58-9fac-943d5c841059/CrXWoL3DAPmaQmeb8ZcAzU",
  test: "https://api.defender.openzeppelin.com/actions/2f457ccb-01be-40f7-a6a7-851519128d54/runs/webhook/d2a70b55-ce91-4a58-9fac-943d5c841059/PWzjqXCMEyANnPwLn2Nwjq",
  production:
    "https://api.defender.openzeppelin.com/actions/c5464f91-2f5a-46b1-9c06-4f9d481c8489/runs/webhook/d2a70b55-ce91-4a58-9fac-943d5c841059/2PxgGefrFGYpnDkXk2ykLh",
};

const opUrl =
  opUrls[(process.env.REACT_APP_ENV as Environment) || "development"];

export default opUrl;
